module.exports = __webpack_public_path__ + "static/media/template_mobile_image.1ef44f79.png";